import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { deleteMusicLink } from 'redux/music-links/actions';

import TooltipCommon from 'components/common/TooltipCommon';
import TooltipButton from 'components/elements/buttons/TooltipButton';

import './MusicLinkDeleteIcon.css';

const MusicLinkDeleteIcon = ({
  musicLinkId,
  deleteMusicLink,
}) => {
  const { t } = useTranslation();
  const [ popupOpen, setPopupOpen ] = useState(false);

  const renderTooltipContent = () => (
    <div className="tooltip-content">
      <div className="message-text">
        <div>{t("Are you sure you want to delete this link?")}</div>
        <div>{t("You can't undo this action.")}</div>
      </div>

      <div className="buttons-block">
        <TooltipButton
          onClick={() => { setPopupOpen(false); }}
        >
          {t("Cancel")}
        </TooltipButton>
        <TooltipButton
          negative
          onClick={() => deleteMusicLink(musicLinkId)}
        >
          {t("Delete")}
        </TooltipButton>
      </div>
    </div>
  );

  const onPopupClose = useCallback(() => {
    setPopupOpen(false);
  }, []);

  return (
    <TooltipCommon
      key={`delete-music-link-tooltip-key-${musicLinkId}`}
      overlayClassName="delete-music-link-tooltip__component"
      header={t("Delete Link")}
      placement="bottom"
      trigger="click"
      visible={popupOpen}
      closeIcon
      onClose={onPopupClose}
      overlay={renderTooltipContent()}
    >
      <div className="music-link-delete-icon__component">
        <div
          className="desktop-icon"
          onClick={() => { setPopupOpen(true); }}
          role="button"
          tabIndex={-1}
        >
          <div className="icon" />
        </div>
      </div>
    </TooltipCommon>
  );
};

MusicLinkDeleteIcon.propTypes = {
  musicLinkId: PropTypes.number,
  deleteMusicLink: PropTypes.func,
};
MusicLinkDeleteIcon.defaultProps = {
  musicLinkId: null,
  deleteMusicLink: null,
};

export default connect(
  null,
  {
    deleteMusicLink,
  },
)(MusicLinkDeleteIcon);
